import React from "react";
import styles from "./NewUser.module.css";
import Loader from "../../../components/Loader";
import Alert from "../../../components/Alert";
import { useTranslation } from "react-i18next";
import Button from "../../../components/Button";
import { client } from "../../../utils/api-client";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Dropdown from "../../../components/Dropdown";

const EditUser = () => {
  const { t } = useTranslation();
  const params = useParams();
  const pad = (n) => n.toString().padStart(2, "0");
  const [userId] = React.useState(params.userId);
  const [isLoading, setIsLoading] = React.useState(true);
  const [error, setError] = React.useState("");
  const navigate = useNavigate();
  const [userData, setUserData] = React.useState();
  const [birthday, setBirthday] = React.useState({
    day: "",
    month: "",
    year: "",
  });
  const statusOptions = [
    { value: "active", label: "Activo" },
    { value: "inactive", label: "Inactivo" },
    { value: "temporarily_banned", label: "Temporalmente desactivado" },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    client(`users/${userId}.json`).then((user) => {
      setUserData(user);
      console.log(user);
      if (user.birthday) {
        const date = new Date(user.birthday);
        setBirthday({
          day: pad(date.getUTCDate()),
          month: pad(date.getUTCMonth() + 1),
          year: date.getUTCFullYear(),
        });
      }
      setIsLoading(false);
    });
  }, [userId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusChange = (newStatus) => {
    setUserData((prev) => ({
      ...prev,
      status: newStatus,
    }));
  };

  const handleBirthdayChange = (e) => {
    const { name, value } = e.target;
    const updatedBirthday = {
      ...birthday,
      [name]: value,
    };
    setBirthday(updatedBirthday);
    setUserData((prev) => ({
      ...prev,
      birthday: `${updatedBirthday.year}-${pad(updatedBirthday.month)}-${pad(
        updatedBirthday.day
      )}`,
    }));
  };

  const validatePresence = (fieldsObject) => {
    let missingFields = [];
    let valid = true;

    Object.keys(fieldsObject).forEach((field) => {
      if (fieldsObject[field] === "") {
        valid = false;
        missingFields.push(field);
      }
    });

    return valid ? valid : missingFields;
  };

  const markRequiredFields = (form, missingFields) => {
    missingFields.forEach((field) =>
      form.elements[field].classList.add(styles.required)
    );
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    setIsLoading(true);

    const { name, first_last_name, second_last_name, email, membership } =
      ev.target.elements;

    const requiredFieldsPresent = validatePresence({
      name: name.value,
      first_last_name: first_last_name.value,
      second_last_name: second_last_name.value,
      membership: membership.value,
      email: email.value,
    });

    if (requiredFieldsPresent === true) {
      client(`users/${userId}.json`, {
        method: "PUT",
        body: JSON.stringify({ user: userData }),
      })
        .then(() => {
          setIsLoading(false);
          navigate(`/admin/users/${userId}`);
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err);
        });
    } else {
      setIsLoading(false);
      setError(t("register.missingFields"));
      markRequiredFields(ev.target, requiredFieldsPresent);
    }
  };

  return (
    <div className={styles.wrapper}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          {console.log(userData)}
          {error !== "" && <Alert>{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <div>
              <label className={styles.requiredLabel}>
                {t("register.name")}
              </label>
              <input
                className={styles.input}
                id="name"
                type="text"
                name="first_name"
                value={userData.first_name}
                onChange={handleInputChange}
              ></input>
            </div>
            <div className={styles.inputGroup}>
              <div>
                <label className={styles.requiredLabel}>
                  {t("register.firstLastName")}
                </label>
                <input
                  className={styles.input}
                  id="first_last_name"
                  type="text"
                  name="first_last_name"
                  value={userData.first_last_name}
                  onChange={handleInputChange}
                ></input>
              </div>
              <div>
                <label className={styles.requiredLabel}>
                  {t("register.secondLastName")}
                </label>
                <input
                  className={styles.input}
                  id="second_last_name"
                  type="text"
                  name="second_last_name"
                  value={userData.second_last_name}
                  onChange={handleInputChange}
                ></input>
              </div>
            </div>
            <div>
              <label className={styles.label}>
                {t("register.displayName")}
              </label>
              <input
                className={styles.input}
                id="display_name"
                type="text"
                name="display_name"
                value={userData.display_name}
                onChange={handleInputChange}
              ></input>
            </div>
            <div>
              <label className={styles.requiredLabel}>
                {t("register.email")}
              </label>
              <input
                className={styles.input}
                id="email"
                type="text"
                name="email"
                value={userData.email}
                onChange={handleInputChange}
              ></input>
            </div>
            <div>
              <label className={styles.requiredLabel}>
                {t("register.membership")}
              </label>
              <input
                className={styles.input}
                id="membership"
                type="text"
                name="membership"
                value={userData.membership}
                onChange={handleInputChange}
              ></input>
            </div>
            <label className={styles.label}>{t("register.dateOfBirth")}</label>
            <div className={styles.birthdayField}>
              <input
                className={styles.input}
                id="day"
                type="text"
                name="day"
                placeholder="DD"
                value={birthday.day}
                onChange={handleBirthdayChange}
              ></input>
              <div className={styles.divider}>/</div>
              <input
                className={styles.input}
                id="month"
                type="text"
                name="month"
                placeholder="MM"
                value={birthday.month}
                onChange={handleBirthdayChange}
              ></input>
              <div className={styles.divider}>/</div>
              <input
                className={`${styles.input} ${styles.yearInput}`}
                id="year"
                type="text"
                name="year"
                placeholder={t("register.year")}
                value={birthday.year}
                onChange={handleBirthdayChange}
              ></input>
            </div>
            <div className={styles.inputGroup}>
              <div>
                <label className={styles.label}>{t("register.ghinId")}</label>
                <input
                  className={styles.input}
                  id="ghin"
                  type="text"
                  name="ghin"
                  value={userData.ghin}
                  onChange={handleInputChange}
                ></input>
              </div>
              <div>
                <label className={styles.label}>
                  {t("register.handicapIndex")}
                </label>
                <input
                  className={styles.input}
                  id="hi"
                  type="text"
                  name="hi"
                  value={userData.hi}
                  onChange={handleInputChange}
                ></input>
              </div>
            </div>
            <div>
              <label className={styles.label}>{t("register.status")}</label>
              <Dropdown
                options={statusOptions}
                onChange={handleStatusChange}
                active={userData.status}
                className={styles.dropdown}
              />
            </div>
            <div className={styles.actionsWrapper}>
              <Button className={styles.submitButton} type="submit">
                {t("admin.users.updateUser")}
              </Button>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default EditUser;
